import React, {useEffect, useState, Fragment, useMemo} from "react";
import {connect} from "react-redux";
import {translate} from '@elements/translations';
import Loading from "../../shared/components/Loading"
import {requireData} from "../actions/actions";
import {getDeclineReasons, getListFetchingState, getListItems} from "../reducer/rootReducer";
import {FETCHING_STATE, formatDate, noop} from "../../shared/utils";
import TableRowItem from "./TableRowItem";

const Base = ({fetchingState, items, listStartDate, listEndDate, declineReasons, onLoadData = noop}) => {

    useEffect(function () {
        if (!fetchingState) {
            onLoadData({startDate: listStartDate, endDate: listEndDate})
        }
    }, [fetchingState]);

    // initial sorting: date descending
    const [sortField, setSortField] = useState('date');
    const [sortDirection, setSortDirection] = useState('desc');

    const handleSorting = (field) => {
        setSortField(field);
        setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
    };

    const sortedItems = sortField ? [...items].sort((a, b) => {
            let result = 0;
            if (sortField === 'totalNumeric') {
                result = a[sortField] - b[sortField];
            } else if (sortField === 'date' || sortField === 'validThrough') {
                result = new Date(a[sortField]) - new Date(b[sortField]);
            } else {
                const aValue = (a[sortField] || '').toString();
                const bValue = (b[sortField] || '').toString();
                result = aValue.localeCompare(bValue);
            }
            return sortDirection === 'asc' ? result : -result;
        }) : items;


    return (
        <Fragment>
            {fetchingState === FETCHING_STATE.ERROR ? (
                <div className="alert alert-danger">
                    <h5 className="alert-heading">{translate('offers.fetching-error')}</h5>
                </div>
            ) : null}

            <div className="position-relative">
                {fetchingState === FETCHING_STATE.PENDING ? (
                    <Loading headline={translate('loading-spinner.label')} />
                ) : null}

                <div className="table-responsive">
                    <table className="table mt-4">
                        <thead>
                        <tr>
                            <th width={'160px'}><button type={"button"} className={`table__head-sort ${sortField === 'date' ? 'is-sorting-active' : ''} ${sortField === 'date' && sortDirection === 'desc' ? 'is-sorting-desc' : ''}`} onClick={() => handleSorting('date')}>{translate('offers.date')}  <span className={'icon icon-chevron table__head-sort-icon'} aria-label={'todo'}></span></button></th>
                            <th width={'140px'}><button type={"button"} className={`table__head-sort ${sortField === 'number' ? 'is-sorting-active' : ''} ${sortField === 'number' && sortDirection === 'desc' ? 'is-sorting-desc' : ''}`} onClick={() => handleSorting('number')}>{translate('offers.offer-number')}  <span className={'icon icon-chevron table__head-sort-icon'} aria-label={'todo'}></span></button></th>
                            <th><button type={"button"} className={`table__head-sort ${sortField === 'reference' ? 'is-sorting-active' : ''} ${sortField === 'reference' && sortDirection === 'desc' ? 'is-sorting-desc' : ''}`} onClick={() => handleSorting('reference')}>{translate('offers.reference')}  <span className={'icon icon-chevron table__head-sort-icon'} aria-label={'todo'}></span></button></th>
                            <th width={'160px'}><button type={"button"} className={`table__head-sort ms-auto ${sortField === 'totalNumeric' ? 'is-sorting-active' : ''} ${sortField === 'totalNumeric' && sortDirection === 'desc' ? 'is-sorting-desc' : ''}`} onClick={() => handleSorting('totalNumeric')}>{translate('offers.total')}  <span className={'icon icon-chevron table__head-sort-icon'} aria-label={'todo'}></span></button></th>
                            <th width={'130px'}><button type={"button"} className={`table__head-sort ${sortField === 'validThrough' ? 'is-sorting-active' : ''} ${sortField === 'validThrough' && sortDirection === 'desc' ? 'is-sorting-desc' : ''}`} onClick={() => handleSorting('validThrough')}>{translate('offers.valid-through')}  <span className={'icon icon-chevron table__head-sort-icon'} aria-label={'todo'}></span></button></th>
                            <th></th>
                        </tr>
                        </thead>
                        {fetchingState === FETCHING_STATE.SUCCESS ? (
                            <tbody>
                            {sortedItems?.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className={'border-bottom-0'}>
                                        <div className="alert alert-light">{translate('offers.no-open-orders')}</div>
                                    </td>
                                </tr>
                            ) : sortedItems.map((item) => (<TableRowItem item={item} key={item.id} declineReasons={declineReasons} />))}
                            </tbody>
                        ) : null}
                    </table>
                </div>

            </div>
        </Fragment>
    );
};


const mapStateToProps = (state) => {
    return ({
        fetchingState: getListFetchingState(state),
        items: getListItems(state),
        declineReasons: getDeclineReasons(state)
    });
};

export const mapDispatchToProps = (dispatch) => {
    return {
        onLoadData: (filter) => dispatch(requireData(filter)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Base)